import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const HeroSection = ({ onContactClick }) => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center pt-24 md:pt-32 pb-16 md:pb-24 px-5 md:px-12 lg:px-20 bg-black overflow-hidden"
    >
      {/* Subtle gradient accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#6DBE2E]/[0.02] to-transparent pointer-events-none" />
      
      <div className="max-w-6xl mx-auto w-full relative">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-12 lg:gap-8">
          {/* Left: Text content */}
          <div className="max-w-2xl lg:max-w-xl">
            {/* Mobile brand text - shown only on mobile */}
            <div className="lg:hidden mb-8">
              <span className="text-2xl md:text-3xl tracking-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                <span className="text-white font-semibold">Harlem</span>
                <span className="text-[#6DBE2E] font-bold"> Leads</span>
              </span>
            </div>
            
            <p className="text-[#6DBE2E] text-[11px] md:text-xs font-medium tracking-[0.2em] uppercase mb-6 md:mb-8 animate-fade-in-up opacity-0">
              Strategic Outbound Partner
            </p>
            
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-medium text-white leading-[1.1] tracking-tight mb-8 md:mb-10 animate-fade-in-up opacity-0 delay-100">
              We open doors.<br />You close deals.
            </h1>

            <p className="text-white/50 text-base md:text-lg leading-relaxed max-w-lg mb-8 md:mb-12 animate-fade-in-up opacity-0 delay-200">
              Outbound that sounds like you, reaches the right people, and protects your reputation. 
              We handle the prospecting. You take the meetings.
            </p>

            <Button
              onClick={onContactClick}
              data-testid="hero-primary-cta"
              className="premium-btn bg-[#6DBE2E] text-black hover:bg-[#5CAD25] rounded-none font-semibold px-6 md:px-8 py-5 md:py-6 text-sm group animate-fade-in-up opacity-0 delay-300"
            >
              Start a Conversation
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform duration-300" />
            </Button>
          </div>

          {/* Right: Large logo - desktop only */}
          <div className="hidden lg:flex items-center justify-center lg:flex-1 animate-fade-in opacity-0 delay-400">
            <img 
              src="/logo.png" 
              alt="Harlem Leads" 
              className="w-[420px] xl:w-[500px] h-auto opacity-90 drop-shadow-[0_0_80px_rgba(109,190,46,0.15)]"
              data-testid="hero-logo"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
